import styled from 'styled-components';

export const Placeholder = styled.div`
  color: ${({ theme }) => theme.colors.fontSilverLight};
`;

export const ParticipantsWrap = styled.div`
  align-items: flex-end;
  display: flex;
  justify-content: flex-end;
  font-size: 12px;
  margin-right: 10px;
  width: 150px;
  padding-top: 15px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.fontSilverLight};
`;

export const MeetingNote = styled.div`
   display: flex;
`;

export const ReactQuillWrappedContainer = styled.div`
   width: 98%;
`;

export const RatePannelWrapper = styled.div`
  padding-top: 15px;
  min-width: 165px;
`;

export const MeetingInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-top: 15px;
  min-width: 125px;
`;

export const CreatorName = styled.div`
  font-weight: 500;
`;

export const Date = styled.div`
  font-weight: normal;
`;

export const NoteInfo = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ControlsWrap = styled.div`
  margin-top: 25px;
  opacity: 0;
`;

export const NoteWrap = styled.div`
  color: ${({ theme }) => theme.colors.mainDark};
  &:hover {
   ${ControlsWrap} {
    opacity: 1;
   }
  }
`;

export const CreatorDataWrap = styled.div`
  font-size: 12px;
  margin-right: 10px;
  width: 250px;
  padding-top: 15px;
  color: ${({ theme }) => theme.colors.fontSilverLight};
`;



// WEBPACK FOOTER //
// ./src/components/notes-simple-list/meeting-notes-list-item/styles.js